import { ComponentType, SVGProps } from 'react';
import { PDFAwsIcon, PDFCertificateIcon, PDFFacebookIcon, PDFGithubIcon, PDFGoogleIcon, PDFIbmIcon, PDFInstagramIcon, PDFLinkedinIcon, PDFLinkIcon, PDFMediumIcon, PDFMicrosoftIcon, PDFOracleIcon, PDFRedditIcon, PDFStackOverflowIcon, PDFXIcon, PDFYoutubeIcon } from '../components/pdf-icons';

// Icons
import { AmazonIcon } from '@shared/icons/AmazonIcon';
import { OracleIcon } from '@shared/icons/OracleIcon';
import { IbmIcon } from '@shared/icons/IbmIcon';
import { MicrosoftIcon } from '@shared/icons/MicrosoftIcon';
import { UserCloseIcon } from '@shared/icons/UserCloseIcon';
import { AddFolderIcon } from '@shared/icons/AddFolderIcon';
import { AlignLeftIcon } from '@shared/icons/AlignLeftIcon';
import CertificateIcon from '@shared/icons/CertificateIcon';
import GoogleIcon from '@shared/icons/GoogleIcon';
import LinkedinIcon from '@shared/icons/LinkedinIcon';
import XIcon from '@shared/icons/XIcon';
import FacebookIcon from '@shared/icons/FacebookIcon';
import GithubIcon from '@shared/icons/GithubIcon';
import LinkIcon from '@shared/icons/LinkIcon';
import MediumIcon from '@shared/icons/MediumIcon';
import InstagramIcon from '@shared/icons/InstagramIcon';
import RedditIcon from '@shared/icons/RedditIcon';
import StackOverflowIcon from '@shared/icons/StackOverflowIcon';
import YoutubeIcon from '@shared/icons/YoutubeIcon';
import ThreadIcon from '@shared/icons/ThreadIcon';
import DownloadIcon from '@shared/icons/DownloadIcon';
import PencilIcon from '@shared/icons/PencilIcon';
import PDFThreadIcon from '../components/pdf-icons/ThreadIcon';
interface SocialPlatformConfig {
  icon: ComponentType<SVGProps<SVGSVGElement>>;
  pdfIcon: ComponentType<{
    color?: string;
  }>;
  domains: string[];
}
export const SOCIAL_PLATFORMS: Record<string, SocialPlatformConfig> = {
  LINKEDIN: {
    icon: LinkedinIcon,
    pdfIcon: PDFLinkedinIcon,
    domains: ['linkedin.com']
  },
  GITHUB: {
    icon: GithubIcon,
    pdfIcon: PDFGithubIcon,
    domains: ['github.com']
  },
  X: {
    icon: XIcon,
    pdfIcon: PDFXIcon,
    domains: ['x.com', 'twitter.com']
  },
  FACEBOOK: {
    icon: FacebookIcon,
    pdfIcon: PDFFacebookIcon,
    domains: ['facebook.com', 'fb.com']
  },
  GOOGLE: {
    icon: GoogleIcon,
    pdfIcon: PDFGoogleIcon,
    domains: ['google.com']
  },
  MEDIUM: {
    icon: MediumIcon,
    pdfIcon: PDFMediumIcon,
    domains: ['medium.com']
  },
  INSTAGRAM: {
    icon: InstagramIcon,
    pdfIcon: PDFInstagramIcon,
    domains: ['instagram.com']
  },
  REDDIT: {
    icon: RedditIcon,
    pdfIcon: PDFRedditIcon,
    domains: ['reddit.com']
  },
  STACKOVERFLOW: {
    icon: StackOverflowIcon,
    pdfIcon: PDFStackOverflowIcon,
    domains: ['stackoverflow.com']
  },
  YOUTUBE: {
    icon: YoutubeIcon,
    pdfIcon: PDFYoutubeIcon,
    domains: ['youtube.com']
  },
  THREADS: {
    icon: ThreadIcon,
    pdfIcon: PDFThreadIcon,
    domains: ['threads.net']
  },
  DEFAULT: {
    icon: LinkIcon,
    pdfIcon: PDFLinkIcon,
    domains: []
  }
} as const;
export const CERTIFICATIONS = {
  AWS: {
    icon: AmazonIcon,
    pdfIcon: PDFAwsIcon
  },
  Amazon: {
    icon: AmazonIcon,
    pdfIcon: PDFAwsIcon
  },
  GOOGLE: {
    icon: GoogleIcon,
    pdfIcon: PDFGoogleIcon
  },
  IBM: {
    icon: IbmIcon,
    pdfIcon: PDFIbmIcon
  },
  Oracle: {
    icon: OracleIcon,
    pdfIcon: PDFOracleIcon
  },
  Microsoft: {
    icon: MicrosoftIcon,
    pdfIcon: PDFMicrosoftIcon
  },
  DEFAULT: {
    icon: CertificateIcon,
    pdfIcon: PDFCertificateIcon
  }
} as const;
export type SocialPlatform = keyof typeof SOCIAL_PLATFORMS;
export type Certification = keyof typeof CERTIFICATIONS;
export const ICON_MAP_TO_ACTION_ITEMS = [{
  keywords: ['download'],
  icon: <DownloadIcon className="size-4" />
}, {
  keywords: ['deactivate'],
  icon: <UserCloseIcon className="fill-frost-900 size-5" />
}, {
  keywords: ['edit'],
  icon: <PencilIcon className="fill-frost-900 size-4" />
}, {
  keywords: ['view', 'project'],
  icon: <AlignLeftIcon className="fill-frost-900 size-4" />
}, {
  keywords: ['edit', 'project'],
  icon: <PencilIcon className="fill-frost-900 size-4" />
}, {
  keywords: ['create', 'project'],
  icon: <AddFolderIcon className="fill-frost-900 size-5" />
}];
export const ORG_ICONS_BG_STYLES: {
  match: string;
  bgClass: string;
}[] = [{
  match: 'google',
  bgClass: ''
}];